// TabsContainerInformeContext.jsx
import React, { createContext, useState, useContext } from 'react';

// Créer le contexte
const TabsContainerInformeContext = createContext();

// Provider
export const TabsContainerInformeProvider = ({ children }) => {
  // État de l'onglet actif
  const [activeTab, setActiveTab] = useState(0);

  return (
    <TabsContainerInformeContext.Provider
      value={{
        activeTab,
        setActiveTab,
      }}
    >
      {children}
    </TabsContainerInformeContext.Provider>
  );
};

// Hook personnalisé pour utiliser le contexte
export const useTabsContainerInforme = () => {
  const context = useContext(TabsContainerInformeContext);
  if (!context) {
    throw new Error('useTabsContainerInforme must be used within TabsContainerInformeProvider');
  }
  return context;
};

// Export par défaut du contexte
export default TabsContainerInformeContext;